<template>
    <div class="licence__list">
        <div class="licence__list_header">
            <view-actions
                :title="'Licences'"
                :cancel-button-active="false"
                :submit-button-text="'New offer'"
                :submit-button-active="user.isCourseLicenceManager() ? true : false"
                @emit-submit="createlicence"
            />
        </div>
        <div class="licence__list_main">
            <component-list
                :component-table="LicenceListTable"
                :component-table-name="'licences'"
                :empty-state-title="'Offers of course licences will appear here.'"
                :filter-search-queryable="true"
                :filter-select-active="true"
                :filter-select-items="filtersSelect"
                :item-name="['licence', 'licences']"
                :get-pagination-getter="'getEbsLicencesPagination'"
                :get-items-getter="'getEbsLicences'"
                :get-items-dispatch="'ebsLicencesGet'"
                :table-preferences-active="true"
            />
        </div>
    </div>
</template>

<script>
import ViewActions from '@/components/default/shared/ViewActions'
import ComponentList from '@/components/default/shared/ComponentList'
import LicenceListTable from '@/components/ebs/licences/list/LicenceListTable'
import { User } from '@/User'

export default {
  name: 'licence-list',
  components: { ComponentList, ViewActions },
  data () {
    return {
      user: new User(),
      LicenceListTable
    }
  },
  computed: {
    filtersSelect () {
      return [
        {
          key: 'customers',
          label: 'Customers',
          type: 'multiselect',
          getItemsGetter: 'getLmsSuperadminCustomersMappedIdNameStatus',
          getItemsGetterMapped: 'getLmsSuperadminCustomersMappedLabelValue',
          getItemsDispatch: 'lmsSuperadminCustomersGetForCourseLicenceManager',
          getPaginationGetter: 'getLmsSuperadminCustomersPagination',
          itemName: ['customer', 'customers'],
          searchQueryable: true,
          tableLabels: [
            {
              key: 'name',
              title: 'Name',
              type: 'string',
              sortable: true,
              queryable: true
            }
          ]
        },
        {
          key: 'courses',
          label: 'Courses',
          type: 'multiselect',
          getItemsGetter: 'getEbsCoursesMappedIdNameStatusLabels',
          getItemsGetterMapped: 'getEbsCoursesMappedLabelValue',
          getItemsDispatch: 'ebsCoursesGet',
          getPaginationGetter: 'getEbsCoursesPagination',
          itemName: ['course', 'courses'],
          searchQueryable: true,
          tableLabels: [
            {
              key: 'name',
              title: 'Name',
              type: 'string',
              sortable: true,
              queryable: true
            }
          ]
        },
        {
          key: 'dates',
          label: 'Dates range',
          type: 'date'
        },
        {
          key: 'status',
          label: 'Status',
          type: 'checkbox',
          values: [
            {
              label: 'Active',
              value: 'accepted'
            },
            {
              label: 'Suspended',
              value: 'suspended'
            }
          ]
        }
      ]
    }
  },
  methods: {
    createlicence () {
      this.$router.push({ name: 'ebs-licence-add' })
    }
  }
}
</script>
